var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSchool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.055 2.185a.63.63 0 01.815-.067l.074.067 4.911 5.282a.615.615 0 01.155.323l.007.091v2.476h5.376c.302 0 .552.22.599.508l.008.098v11.641c0 .302-.22.552-.509.599l-.098.008H1.607a.607.607 0 01-.599-.509L1 22.604V10.963c0-.3.22-.551.509-.598l.098-.008h5.376V7.881a.61.61 0 01.105-.342l.057-.072 4.91-5.282zm.445 15.106c-.54 0-.987.41-1.044.936l-.006.114v3.657h2.1v-3.657c0-.58-.471-1.05-1.05-1.05zm0-13.802L8.196 8.12v13.878h2.041v-3.657a2.265 2.265 0 012.263-2.263c1.196 0 2.178.932 2.258 2.108l.005.155v3.657h2.041V8.12L12.5 3.489zm10.287 10.818h-4.77v7.69h4.77v-7.69zm-15.804 0h-4.77v7.69h4.77v-7.69zm0-2.737h-4.77v1.523h4.77V11.57zm15.804 0h-4.77v1.523h4.77V11.57zM12.5 6.685a2.473 2.473 0 012.469 2.469 2.472 2.472 0 01-2.47 2.468 2.471 2.471 0 01-2.467-2.468A2.471 2.471 0 0112.5 6.685zm0 1.213a1.256 1.256 0 000 2.51 1.256 1.256 0 000-2.51z",
    fill: "#333",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "7fcc228660b6c5492267be822c331aac.svg";
export { SvgIconSchool as ReactComponent };